export const latex_syntax ={
  "Lowercase Greek Letters": [
    { "syntax": "\\alpha", "html": "α", "description": "Greek letter alpha" },
    { "syntax": "\\beta", "html": "β", "description": "Greek letter beta" },
    { "syntax": "\\gamma", "html": "γ", "description": "Greek letter gamma" },
    { "syntax": "\\delta", "html": "δ", "description": "Greek letter delta" },
    { "syntax": "\\epsilon", "html": "ε", "description": "Greek letter epsilon" },
    { "syntax": "\\lambda", "html": "λ", "description": "Greek letter lambda" },
    { "syntax": "\\pi", "html": "π", "description": "Greek letter pi" },
    { "syntax": "\\sigma", "html": "σ", "description": "Greek letter sigma" },
    { "syntax": "\\omega", "html": "ω", "description": "Greek letter omega" }
  ],
  "Uppercase Greek Letters": [
    { "syntax": "\\Gamma", "html": "Γ", "description": "Greek letter Gamma" },
    { "syntax": "\\Delta", "html": "Δ", "description": "Greek letter Delta" },
    { "syntax": "\\Theta", "html": "Θ", "description": "Greek letter Theta" },
    { "syntax": "\\Lambda", "html": "Λ", "description": "Greek letter Lambda" },
    { "syntax": "\\Pi", "html": "Π", "description": "Greek letter Pi" },
    { "syntax": "\\Sigma", "html": "Σ", "description": "Greek letter Sigma" },
    { "syntax": "\\Omega", "html": "Ω", "description": "Greek letter Omega" }
  ],
  "Operators": [
    { "syntax": "\\sum", "html": "∑", "description": "Summation" },
    { "syntax": "\\prod", "html": "∏", "description": "Product" },
    { "syntax": "\\int", "html": "∫", "description": "Integral" },
    { "syntax": "\\lim", "html": "lim", "description": "Limit" },
    { "syntax": "\\frac{a}{b}", "html": "a/b", "description": "Fraction a/b" },
    { "syntax": "\\sqrt{m}", "html": "√m", "description": "Square root" },
    { "syntax": "\\sqrt[n]{m}", "html": "<sup>n</sup>√m", "description": "n-th root", "toolbox": "true", "fixTag": "sup" },
    { "syntax": "m_n", "html": "m<sub>n</sub>", "description": "Subscript", "toolbox": "true" ,  },
    { "syntax": "m^n", "html": "m<sup>n</sup>", "description": "Superscript", "toolbox": "true" , "fixTag": "sup"}

  ],
  "Relations": [
    { "syntax": "=", "html": "=", "description": "Equals" },
    { "syntax": "\\neq", "html": "≠", "description": "Not equal" },
    { "syntax": "<", "html": "<", "description": "Less than" },
    { "syntax": ">", "html": ">", "description": "Greater than" },
    { "syntax": "\\leq", "html": "≤", "description": "Less than or equal" },
    { "syntax": "\\geq", "html": "≥", "description": "Greater than or equal" },
    { "syntax": "\\approx", "html": "≈", "description": "Approximately equal" }
  ],
  "Arrows": [
    { "syntax": "\\rightarrow", "html": "→", "description": "Right arrow" },
    { "syntax": "\\leftarrow", "html": "←", "description": "Left arrow" },
    { "syntax": "\\Rightarrow", "html": "⇒", "description": "Double right arrow" },
    { "syntax": "\\Leftarrow", "html": "⇐", "description": "Double left arrow" },
    { "syntax": "\\leftrightarrow", "html": "↔", "description": "Left right arrow" }
  ],
  "Formatting": [
    { "syntax": "\\text{Text}", "html": "Text", "description": "Insert text" },
    { "syntax": "\\newline", "html": "<br>", "description": "Line break" },
    { "syntax": "\\\\", "html": "<br>", "description": "Line break inside equation" },
    { "syntax": "\\left(...\\right)", "html": "(...)", "description": "Auto-sized parentheses" },
    { "syntax": "\\cdot", "html": "·", "description": "Multiplication dot" }
  ]
}


export const SUPERSCRIPT_UNICODE_MAPPING = {
  "1": "&#x00B9;",
  "2": "&#x00B2;",
  "3": "&#x00B3;",
  "4": "&#x2074;",
  "5": "&#x2075;",
  "6": "&#x2076;",
  "7": "&#x2077;",
  "8": "&#x2078;",
  "9": "&#x2079;"
} 

export const SUPERSCRIPT_MAPPING = {
  '0': '⁰',
  '1': '¹',
  '2': '²',
  '3': '³',
  '4': '⁴',
  '5': '⁵',
  '6': '⁶',
  '7': '⁷',
  '8': '⁸',
  '9': '⁹',
  'a': 'ᵃ',
  'b': 'ᵇ',
  'c': 'ᶜ',
  'd': 'ᵈ',
  'e': 'ᵉ',
  'f': 'ᶠ',
  'g': 'ᵍ',
  'h': 'ʰ',
  'i': 'ⁱ',
  'j': 'ʲ',
  'k': 'ᵏ',
  'l': 'ˡ',
  'm': 'ᵐ',
  'n': 'ⁿ',
  'o': 'ᵒ',
  'p': 'ᵖ',
  'q': 'q', // rare, might not render everywhere
  'r': 'ʳ',
  's': 'ˢ',
  't': 'ᵗ',
  'u': 'ᵘ',
  'v': 'ᵛ',
  'w': 'ʷ',
  'x': 'ˣ',
  'y': 'ʸ',
  'z': 'ᶻ',
};
